// removed by extract-text-webpack-plugin
module.exports = {"container":"UpcomingView__container___1bbzX","placeholder":"UpcomingView__placeholder___1UnXj"};